import { render, staticRenderFns } from "./dashboardOld.vue?vue&type=template&id=d6365460&scoped=true"
import script from "./dashboardOld.vue?vue&type=script&lang=js"
export * from "./dashboardOld.vue?vue&type=script&lang=js"
import style0 from "./dashboardOld.vue?vue&type=style&index=0&id=d6365460&prod&lang=scss"
import style1 from "./dashboardOld.vue?vue&type=style&index=1&id=d6365460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6365460",
  null
  
)

export default component.exports